import { useContext, useState } from "react";
import { AppContext } from "../../App";
import PopUp from "../PopUp";
import FormGroup from "../form/FormGroup";
import TrashIcon from "../../icons/TrashIcon";
import {
	ALLERGEN_PRINT_NAMES,
	DIETS,
	emptyFilter,
	isFilterActive,
	isRisky,
	reasonsLabel,
	riskReasons,
} from "../../utils/allergenFilter";

function EditProductPopup() {
	const {
		cart,
		setCart,
		editingProduct,
		setEditingProduct,
		filteredCategories,
		setEdited,
		setConfirm,
		shop,
		apiSettings,
		allergenFilterEnabled,
	} = useContext(AppContext);
	const configuredFlows = apiSettings?.orders?.flows_number
		? parseInt(apiSettings.orders.flows_number)
		: 5;
	const orderMaxFlow = (cart?.products || []).reduce((max, product) => {
		const flow = parseInt(product?.flow) || 1;
		return flow > max ? flow : max;
	}, 1);
	const totalFlows = Math.max(configuredFlows, orderMaxFlow);
	const flows = [...Array(totalFlows).keys()].map((i) => i + 1);

	const setFlow = (flow) => {
		let nCart = { ...cart };
		nCart.products[editingProduct.i].flow = flow;
		setCart(nCart);
	};

	const subQty = (i) => {
		let nCart = { ...cart };
		if (nCart.products[i].qty > 1) nCart.products[i].qty--;
		setCart(nCart);
		setEdited(true);
	};

	const addQty = (i) => {
		console.log("addQty", i);
		const p = findProduct(editingProduct.data.id);
		//console.log(editingProduct);
		//console.log(p);
		const disableStockCheckPos = apiSettings?.menu_api?.disable_stock_check_operators == 1;
		if (!disableStockCheckPos && (checkProductsStock(p) || checkIngredientsStock(p.stock.ingredients))) {
			setConfirm({
				title: "Prodotto esaurito",
			});
		} else {
			let nCart = { ...cart };
			nCart.products[i].qty++;
			setCart(nCart);
			setEdited(true);
		}
	};

	function findProduct(id) {
		for (const course of filteredCategories) {
			for (const category of course.categories) {
				for (const product of category.products) {
					if (product.id == id) return product;
				}
			}
		}
		return false;
	}

	function checkProductsStock(product) {
		//console.log("checkProductsStock", product.stock);
		if (product.stock && product.stock.product !== false) {
			let stock = product.stock.product;
			for (const element of cart.products) {
				if (element.id == product.id) stock -= element.qty;
			}
			//console.log(stock);
			if (stock == 0) return true;
		}
		return false;
	}

	function checkIngredientsStock(ingredients) {
		for (const i of ingredients) {
			let sum = i.qty;
			for (const product of cart.products) {
				for (const ingredient of product.ingredients) {
					if (ingredient.id == i.ingredient_id) sum -= product.qty;
				}
			}
			if (sum == 0) return true;
		}
		return false;
	}

	const remove = (i) => {
		setConfirm({
			title: "Sei sicuro?",
			message: "",
			onConfirm: async () => {
				let nCart = { ...cart };
				nCart.products.splice(i, 1);
				setCart(nCart);
				setEdited(true);
				setEditingProduct(false);
			},
		});
	};

	// allergia della singola riga: solo per le righe non ancora inviate (quelle inviate sono già in cucina)
	const editingLine = cart.products[editingProduct.i];
	const canEditLineAllergy =
		allergenFilterEnabled && editingLine && !editingLine.item_id && !editingLine.split_from_id;
	const lineFilter = editingLine?.allergy_filter || emptyFilter();

	const toggleLineAllergy = (key, value) => {
		const list = lineFilter[key].includes(value)
			? lineFilter[key].filter((v) => v !== value)
			: [...lineFilter[key], value];
		const next = { ...lineFilter, [key]: list };
		const reasons = [...riskReasons(editingLine, next)];
		for (const vc of editingLine.variants_categories || [])
			for (const group of ["products", "products2"])
				for (const item of vc[group] || [])
					if (item.qty > 0 && isRisky(item, next)) reasons.push(...riskReasons(item, next));
		if (reasons.length) {
			setConfirm({
				title: "Filtro allergie",
				message:
					editingLine.name +
					" contiene: " +
					reasonsLabel(reasons) +
					". Eliminalo e reinseriscilo con il filtro acceso.",
			});
			return;
		}
		let nCart = { ...cart };
		if (isFilterActive(next)) nCart.products[editingProduct.i].allergy_filter = next;
		else delete nCart.products[editingProduct.i].allergy_filter;
		setCart(nCart);
		setEdited(true);
	};

	const setNotes = (notes) => {
		let nCart = { ...cart };
		nCart.products[editingProduct.i].notes = notes;
		setCart(nCart);
	};

	return (
		<PopUp
			size=""
			customClass="cart-edit-product-popup"
			options={{
				onClose: false,
				title: editingProduct.data.name,
				subtitle: "",
				headerButtons: (
					<button onClick={() => remove(editingProduct.i)}>
						<TrashIcon />
					</button>
				),
			}}
		>
			<div className="inner-content">
				<div className="cart-edit-product-body">
					<div className="cart-edit-product-section">
						<h4>Quantità</h4>
						<div className="plus-minus-generic">
							<button onClick={() => subQty(editingProduct.i)}>-</button>
							<div>{editingProduct.data.qty}</div>
							<button onClick={() => addQty(editingProduct.i)}>+</button>
						</div>
					</div>
					<div className="cart-edit-product-section">
						<h4>Portata</h4>
						<div className="cart-flows-buttons">
							{flows.map((el, i) => (
								<button
									key={i}
									className={cart.products[editingProduct.i].flow == el ? "selected" : ""}
									onClick={() => setFlow(el)}
								>
									{"Portata " + el}
								</button>
							))}
						</div>
					</div>
					{canEditLineAllergy && (
						<div className="cart-edit-product-section">
							<h4>Allergie di questo piatto</h4>
							<div className="cart-edit-allergies">
								{Object.entries(ALLERGEN_PRINT_NAMES).map(([id, name]) => (
									<button
										key={id}
										type="button"
										className={lineFilter.allergens.includes(Number(id)) ? "selected" : ""}
										onClick={() => toggleLineAllergy("allergens", Number(id))}
									>
										{name}
									</button>
								))}
								{DIETS.map((diet) => (
									<button
										key={diet.id}
										type="button"
										className={"diet" + (lineFilter.diets.includes(diet.id) ? " selected" : "")}
										onClick={() => toggleLineAllergy("diets", diet.id)}
									>
										{diet.label}
									</button>
								))}
							</div>
						</div>
					)}
					<div className="cart-edit-product-section">
						<h4>Note prodotto</h4>
						<FormGroup
							type="textarea"
							value={cart.products[editingProduct.i].notes}
							onChange={(e) => {
								setNotes(e.target.value);
							}}
						/>
					</div>
				</div>
			</div>
			<div className="popup-footer">
				<div className="buttons-group">
					<button className="button button-2" onClick={() => setEditingProduct(false)}>
						Chiudi
					</button>
				</div>
			</div>
		</PopUp>
	);
}

export default EditProductPopup;
